import {
  EditAttachmentPayload,
  RetrieveAttachmentsPayload,
} from 'app/modules/attachments/requests';

import { downloadFile, post } from 'app/shared/utils/fetchr';
import { GetAttachmentListResponse } from 'app/modules/attachments/responses';

export const downloadAttachment = (id: number, fileName: string) => {
  return downloadFile(`/v1/attachments/download/${id}`, fileName);
};

export const updateAttachment = (
  id: number,
  payload: EditAttachmentPayload,
) => {
  return post(`/v1/attachments/edit/${id}`, payload);
};

export const retrieveAttachments = (
  payload: RetrieveAttachmentsPayload,
): Promise<GetAttachmentListResponse> => {
  return post('/v1/attachments/list', payload);
};
